import { axiosInstance } from "../utils/ApiClient";

export const dashboardSummaryService = {
  // `teamWide: true` skips the sidebar owner scope (team-level config surfaces).
  getSummary: async ({ teamWide = false } = {}) => {
    try {
      const response = await axiosInstance.get("/metrics/dashboard-summary/", {
        skipOwnerScope: teamWide,
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching dashboard summary:", error);
      throw error;
    }
  },
};
